import React, { Component } from 'react';
import axios from 'axios';
import { connect } from 'react-redux';
import { api, versao } from '../../config';
import { getHeaders } from '../../actions/localStorage';
import { formatMoney } from '../../actions';
import Titulo from '../../components/Texto/Titulo';
import Loading from '../../components/Loading';
import Pesquisa from '../../components/Inputs/Pesquisa';
import Paginacao from '../../components/Paginacao/Simples';
import moment from 'moment';
import { verifyAdmin, verifyDeveloper } from '../../utils/verify-admin';

const CHECKOUT_ETAPA_LABELS = {
	cliente: 'Dados pessoais',
	entrega: 'Entrega',
	pagamento: 'Pagamento',
	finalizar: 'Finalizar',
};

function formatCheckoutEtapa(row) {
	const etapa = row.ultimaEtapa;
	if (!etapa) return '—';
	return CHECKOUT_ETAPA_LABELS[etapa] || etapa;
}

function getLastCheckoutError(row) {
	const eventos = row.eventosCheckout || [];
	for (let i = eventos.length - 1; i >= 0; i -= 1) {
		if (eventos[i].tipo === 'erro') return eventos[i];
	}
	return null;
}

function getUltimoCheckoutEm(row) {
	if (row.ultimoCheckoutEm) return row.ultimoCheckoutEm;
	const eventos = row.eventosCheckout || [];
	if (eventos.length > 0) return eventos[eventos.length - 1].em;
	return row.createdAt || row.updatedAt;
}

function buildCheckoutEtapaTitle(row) {
	const eventos = row.eventosCheckout || [];
	if (!eventos.length) return '';
	return eventos
		.slice(-8)
		.map((ev) => {
			const label = CHECKOUT_ETAPA_LABELS[ev.etapa] || ev.etapa;
			const when = ev.em ? moment(ev.em).format('DD/MM HH:mm') : '';
			const detail = ev.detalhes ? ` (${ev.detalhes})` : '';
			return `[${when}] ${label} — ${ev.tipo}: ${ev.mensagem || '—'}${detail}`;
		})
		.join('\n');
}

class CarrinhosAbandonados extends Component {
	state = {
		list: null,
		total: 0,
		error: null,
		loading: true,
		atual: 0,
		limit: 20,
		pesquisa: '',
		dataInicio: '',
		dataFim: '',
		filtrosAvancadosAbertos: false,
		selectedIds: {},
		deleteBusy: false,
		deleteError: '',
		ignoreBusy: false,
		ignoreError: '',
		restoreBusy: false,
		restoreError: '',
		situacao: 'abandonado',
	};

	componentDidMount() {
		const { usuario, history } = this.props;
		if (
			!usuario ||
			!(
				verifyDeveloper(usuario) ||
				verifyAdmin(usuario, 'admin') === true ||
				verifyAdmin(usuario, 'owner') === true
			)
		) {
			history.replace('/');
			return;
		}
		this.load();
	}

	buildParams() {
		const { usuario } = this.props;
		const { atual, limit, pesquisa, dataInicio, dataFim, situacao } = this.state;
		const params = new URLSearchParams();
		params.set('loja', usuario.loja);
		params.set('offset', String(atual));
		params.set('limit', String(limit));
		params.set('situacao', situacao);
		const q = pesquisa.trim();
		if (q.length > 0) params.set('q', q);
		if (dataInicio && dataFim) {
			params.set('dataInicio', dataInicio);
			params.set('dataFim', dataFim);
		}
		return params.toString();
	}

	load = () => {
		const { usuario } = this.props;
		if (!usuario || !usuario.loja) return;
		this.setState({ loading: true, error: null });
		const qs = this.buildParams();
		axios
			.get(`${api}/${versao}/api/carrinhos-abandonados/admin?${qs}`, getHeaders())
			.then((r) => {
				const total = Number(r.data.total);
				const list = r.data.carrinhosAbandonados;
				const { limit } = this.state;
				let nextAtual = this.state.atual;
				if (total === 0) nextAtual = 0;
				else if (nextAtual >= total) nextAtual = Math.max(0, (Math.ceil(total / limit) - 1) * limit);
				if (nextAtual !== this.state.atual) {
					this.setState({ atual: nextAtual }, () => this.load());
					return;
				}
				this.setState({
					list,
					total,
					loading: false,
				});
			})
			.catch((e) => this.setState({ error: e, loading: false, list: [], total: 0 }));
	};

	handleSubmitPesquisa = () => {
		this.setState({ atual: 0 }, () => this.load());
	};

	onChangePesquisa = (ev) => this.setState({ pesquisa: ev.target.value });

	changePage = (offset) => {
		this.setState({ atual: offset }, () => this.load());
	};

	changeSituacao = (situacao) => {
		this.setState({ situacao, atual: 0, selectedIds: {}, pesquisa: '' }, () => this.load());
	};

	applyDateFilters = () => {
		const { dataInicio, dataFim } = this.state;
		if ((dataInicio && !dataFim) || (!dataInicio && dataFim)) {
			alert('Informe data inicial e final para filtrar por período de atualização, ou deixe as duas em branco.');
			return;
		}
		if (dataInicio && dataFim) {
			const a = new Date(dataInicio);
			const b = new Date(dataFim);
			if (a > b) {
				alert('A data inicial não pode ser maior que a data final.');
				return;
			}
		}
		this.setState({ atual: 0 }, () => this.load());
	};

	clearDateFilters = () => {
		this.setState({ atual: 0, dataInicio: '', dataFim: '' }, () => this.load());
	};

	toggleRow = (id) => {
		this.setState((prev) => {
			const selectedIds = { ...prev.selectedIds };
			if (selectedIds[id]) delete selectedIds[id];
			else selectedIds[id] = true;
			return { selectedIds };
		});
	};

	togglePageRows = (checked) => {
		const list = this.state.list;
		this.setState((prev) => {
			const selectedIds = { ...prev.selectedIds };
			if (!list) return { selectedIds };
			for (let i = 0; i < list.length; i++) {
				const id = list[i]._id;
				if (checked) selectedIds[id] = true;
				else delete selectedIds[id];
			}
			return { selectedIds };
		});
	};

	createOrderFromCart = (row) => {
		const { history } = this.props;
		history.push({
			pathname: '/neworder',
			state: {
				fromAbandonedCart: {
					_id: row._id,
					email: row.email,
					nome: row.nome,
					telefone: row.telefone,
					cpf: row.cpf,
					itens: row.itens || [],
				},
			},
		});
	};

	deleteSelected = () => {
		const ids = Object.keys(this.state.selectedIds);
		if (ids.length === 0) return;
		if (!window.confirm(`Excluir ${ids.length} carrinho(s) abandonado(s)? Esta ação não pode ser desfeita.`)) return;
		const { usuario } = this.props;
		this.setState({ deleteBusy: true, deleteError: '' });
		axios
			.post(
				`${api}/${versao}/api/carrinhos-abandonados/admin/excluir?loja=${usuario.loja}`,
				{ ids },
				getHeaders()
			)
			.then(() => {
				this.setState({ selectedIds: {}, deleteBusy: false }, () => this.load());
			})
			.catch(() => {
				this.setState({
					deleteBusy: false,
					deleteError: 'Não foi possível excluir os registros selecionados.',
				});
			});
	};

	ignoreSelected = () => {
		const ids = Object.keys(this.state.selectedIds);
		if (ids.length === 0) return;
		if (
			!window.confirm(
				`Ignorar ${ids.length} carrinho(s) selecionado(s)? Os e-mails passam para a aba Ignorados, deixam de gerar novos registros e os carrinhos atuais são removidos da listagem.`
			)
		)
			return;
		const { usuario } = this.props;
		this.setState({ ignoreBusy: true, ignoreError: '' });
		axios
			.post(
				`${api}/${versao}/api/carrinhos-abandonados/admin/ignorar?loja=${usuario.loja}`,
				{ ids },
				getHeaders()
			)
			.then((r) => {
				const ignoredEmails = Number(r.data.ignoredEmails) || 0;
				if (ignoredEmails === 0) {
					this.setState({
						ignoreBusy: false,
						ignoreError: 'Nenhum e-mail foi adicionado à lista de ignorados.',
					});
					return;
				}
				this.setState(
					{ selectedIds: {}, ignoreBusy: false, situacao: 'ignorados', atual: 0, pesquisa: '' },
					() => this.load()
				);
			})
			.catch(() => {
				this.setState({
					ignoreBusy: false,
					ignoreError: 'Não foi possível ignorar os e-mails selecionados.',
				});
			});
	};

	restoreSelected = () => {
		const emails = Object.keys(this.state.selectedIds);
		if (emails.length === 0) return;
		if (
			!window.confirm(
				`Restaurar ${emails.length} e-mail(s)? Eles voltarão a gerar registros em carrinhos abandonados no checkout.`
			)
		)
			return;
		const { usuario } = this.props;
		this.setState({ restoreBusy: true, restoreError: '' });
		axios
			.post(
				`${api}/${versao}/api/carrinhos-abandonados/admin/restaurar?loja=${usuario.loja}`,
				{ emails },
				getHeaders()
			)
			.then(() => {
				this.setState({ selectedIds: {}, restoreBusy: false }, () => this.load());
			})
			.catch(() => {
				this.setState({
					restoreBusy: false,
					restoreError: 'Não foi possível restaurar os e-mails selecionados.',
				});
			});
	};

	render() {
		const { usuario } = this.props;
		const {
			list,
			loading,
			error,
			atual,
			limit,
			total,
			pesquisa,
			dataInicio,
			dataFim,
			filtrosAvancadosAbertos,
			selectedIds,
			deleteBusy,
			deleteError,
			ignoreBusy,
			ignoreError,
			restoreBusy,
			restoreError,
			situacao,
		} = this.state;

		if (
			!usuario ||
			!(
				verifyDeveloper(usuario) ||
				verifyAdmin(usuario, 'admin') === true ||
				verifyAdmin(usuario, 'owner') === true
			)
		)
			return null;
		if (loading && list == null) return <Loading />;

		const selectedCount = Object.keys(selectedIds).length;
		let selectedOnPage = 0;
		const totalOnPage = list && list.length ? list.length : 0;
		if (list && list.length > 0) {
			for (let i = 0; i < list.length; i++) {
				if (selectedIds[list[i]._id]) selectedOnPage++;
			}
		}
		const allOnPageSelected = totalOnPage > 0 && selectedOnPage === totalOnPage;
		const isIgnorados = situacao === 'ignorados';
		const actionsBusy = deleteBusy || ignoreBusy || restoreBusy;

		return (
			<div className="Clients CarrinhosAbandonados content-box">
				<div className="Page-Title">
					<Titulo tipo="h1" titulo="Carrinhos abandonados" />
				</div>

				<p className="clientesFiltersHint">
					Registros criados quando o cliente avança em &quot;Seus dados&quot; no checkout. Use a aba{' '}
					<strong>Recuperados</strong> para ver compras concluídas no site (mesmo e-mail) — o histórico fica salvo com
					data em &quot;Compra concluída&quot;. A aba <strong>Abandonados</strong> são carrinhos ainda sem pagamento. Em{' '}
					<strong>Ignorados</strong>, e-mails que não geram mais registros (fraude ou abuso).
				</p>

				<div className="CarrinhosAbandonados-situacaoTabs" role="tablist">
					<button
						type="button"
						role="tab"
						className={`CarrinhosAbandonados-situacaoTab${situacao === 'abandonado' ? ' is-active' : ''}`}
						aria-selected={situacao === 'abandonado'}
						onClick={() => this.changeSituacao('abandonado')}
					>
						Abandonados
					</button>
					<button
						type="button"
						role="tab"
						className={`CarrinhosAbandonados-situacaoTab${situacao === 'convertido' ? ' is-active' : ''}`}
						aria-selected={situacao === 'convertido'}
						onClick={() => this.changeSituacao('convertido')}
					>
						Recuperados
					</button>
					<button
						type="button"
						role="tab"
						className={`CarrinhosAbandonados-situacaoTab${situacao === 'todos' ? ' is-active' : ''}`}
						aria-selected={situacao === 'todos'}
						onClick={() => this.changeSituacao('todos')}
					>
						Todos
					</button>
					<button
						type="button"
						role="tab"
						className={`CarrinhosAbandonados-situacaoTab${situacao === 'ignorados' ? ' is-active' : ''}`}
						aria-selected={situacao === 'ignorados'}
						onClick={() => this.changeSituacao('ignorados')}
					>
						Ignorados
					</button>
				</div>

				<div className="clientesToolbar">
					<div className="clientesToolbarTop">
						{!isIgnorados ? (
							<button
								type="button"
								className="clientesToolbarToggle"
								onClick={() =>
									this.setState((s) => ({ filtrosAvancadosAbertos: !s.filtrosAvancadosAbertos }))
								}
								aria-expanded={filtrosAvancadosAbertos}
								aria-label="Abrir ou fechar filtros por período"
								title="Filtros por período"
							>
								<div className={`icon icon-toggle${filtrosAvancadosAbertos ? ' active' : ''}`}>
									<div />
									<div />
									<div />
								</div>
							</button>
						) : null}
						<div className="clientesToolbarSearchWrap">
							<Pesquisa
								valor={pesquisa}
								style={{ margin: 0 }}
								placeholder={isIgnorados ? 'E-mail' : 'E-mail, nome, telefone, CPF ou produto'}
								onChange={this.onChangePesquisa}
								onClick={this.handleSubmitPesquisa}
							/>
						</div>
						<div className="CarrinhosAbandonados-toolbarActions">
							{isIgnorados ? (
								<button
									type="button"
									className="CarrinhosAbandonados-iconBtn CarrinhosAbandonados-iconBtn--restore"
									disabled={selectedCount === 0 || actionsBusy}
									onClick={this.restoreSelected}
									title={`Restaurar selecionados (${selectedCount})`}
									aria-label={`Restaurar selecionados (${selectedCount})`}
								>
									<i className="fas fa-undo" aria-hidden="true" />
								</button>
							) : (
								<>
									<button
										type="button"
										className="CarrinhosAbandonados-iconBtn CarrinhosAbandonados-iconBtn--ignore"
										disabled={selectedCount === 0 || actionsBusy}
										onClick={this.ignoreSelected}
										title={`Ignorar selecionados (${selectedCount})`}
										aria-label={`Ignorar selecionados (${selectedCount})`}
									>
										<i className="fas fa-ban" aria-hidden="true" />
									</button>
									<button
										type="button"
										className="CarrinhosAbandonados-iconBtn CarrinhosAbandonados-iconBtn--delete"
										disabled={selectedCount === 0 || actionsBusy}
										onClick={this.deleteSelected}
										title={`Excluir selecionados (${selectedCount})`}
										aria-label={`Excluir selecionados (${selectedCount})`}
									>
										<i className="fa fa-trash" aria-hidden="true" />
									</button>
								</>
							)}
						</div>
					</div>
					{filtrosAvancadosAbertos && !isIgnorados ? (
						<div className="clientesFiltersDrawer">
							<div className="entregasFiltersExtrasItems">
								<label className="entregasFiltersPanel-field entregasFiltersPanel-field--date">
									<span>
										{situacao === 'convertido' ? 'Compra concluída de' : 'Último checkout de'}
									</span>
									<input
										type="date"
										value={dataInicio}
										onChange={(ev) => this.setState({ dataInicio: ev.target.value })}
									/>
								</label>
								<label className="entregasFiltersPanel-field entregasFiltersPanel-field--date">
									<span>{situacao === 'convertido' ? 'Compra concluída até' : 'Até'}</span>
									<input
										type="date"
										value={dataFim}
										onChange={(ev) => this.setState({ dataFim: ev.target.value })}
									/>
								</label>
							</div>
							<div className="clientesFiltersDrawer-footer">
								<button type="button" className="entregasLimparFiltrosBtn" onClick={this.clearDateFilters}>
									Limpar período
								</button>
								<button type="button" className="clientesAplicarFiltrosBtn" onClick={this.applyDateFilters}>
									Aplicar período
								</button>
							</div>
						</div>
					) : null}
				</div>

				{(dataInicio && !dataFim) || (!dataInicio && dataFim) ? (
					<p className="clientesFiltersHint">Para filtrar por período, preencha as duas datas (de e até).</p>
				) : null}
				{deleteError ? (
					<p className="clientesFiltersHint CarrinhosAbandonados-hintError">{deleteError}</p>
				) : null}
				{ignoreError ? (
					<p className="clientesFiltersHint CarrinhosAbandonados-hintError">{ignoreError}</p>
				) : null}
				{restoreError ? (
					<p className="clientesFiltersHint CarrinhosAbandonados-hintError">{restoreError}</p>
				) : null}

				{error ? (
					<p className="clientesFiltersHint CarrinhosAbandonados-hintError">
						Não foi possível carregar a lista.
					</p>
				) : null}
				{list && list.length === 0 && !loading && !error ? (
					<p className="clientesFiltersHint">
						{situacao === 'convertido'
							? 'Nenhuma compra recuperada registrada neste período.'
							: situacao === 'ignorados'
								? pesquisa.trim()
									? 'Nenhum e-mail ignorado corresponde à busca. Limpe o campo de pesquisa para ver todos.'
									: 'Nenhum e-mail ignorado no momento.'
								: situacao === 'todos'
									? 'Nenhum registro encontrado.'
									: 'Nenhum carrinho abandonado no momento.'}
					</p>
				) : null}

				{list && list.length > 0 ? (
					<>
						<div className="Dashboard">
							<div
								className={`data-table-wrap CarrinhosAbandonados-tableOuter${
									loading ? ' CarrinhosAbandonados-tableOuter--loading' : ''
								}`}
							>
								{loading ? (
									<p className="clientesFiltersHint CarrinhosAbandonados-loadingBanner">Atualizando…</p>
								) : null}
								<table
									className={`data-table CarrinhosAbandonados-table${
										isIgnorados ? ' CarrinhosAbandonados-table--ignorados' : ''
									}`}
								>
								<thead>
									<tr>
										<th className="CarrinhosAbandonados-colCheck">
											<input
												type="checkbox"
												checked={allOnPageSelected}
												onChange={(ev) => this.togglePageRows(ev.target.checked)}
												aria-label="Selecionar todos desta página"
											/>
										</th>
										{isIgnorados ? (
											<th>E-mail</th>
										) : (
											<>
												<th>Último checkout</th>
												<th>Etapa checkout</th>
												<th>E-mail</th>
												<th>Nome</th>
												<th>Telefone</th>
												<th>Itens</th>
												<th>Valor (aprox.)</th>
												<th>E-mail lembrete</th>
												<th>Compra concluída</th>
												<th>Ações</th>
											</>
										)}
									</tr>
								</thead>
								<tbody>
									{list.map((row) => {
										const id = row._id;
										if (isIgnorados) {
											return (
												<tr key={id}>
													<td className="CarrinhosAbandonados-colCheck">
														<input
															type="checkbox"
															checked={Boolean(selectedIds[id])}
															onChange={() => this.toggleRow(id)}
															aria-label={`Selecionar ${row.email}`}
														/>
													</td>
													<td className="CarrinhosAbandonados-colEmail">{row.email}</td>
												</tr>
											);
										}
										const subtotal = (row.itens || []).reduce(
											(sum, i) => sum + Number(i.precoUnitario || 0) * Number(i.quantidade || 1),
											0
										);
										const lastError = getLastCheckoutError(row);
										return (
											<tr key={id}>
												<td className="CarrinhosAbandonados-colCheck">
													<input
														type="checkbox"
														checked={Boolean(selectedIds[id])}
														onChange={() => this.toggleRow(id)}
														aria-label={`Selecionar ${row.email}`}
													/>
												</td>
												<td>{moment(getUltimoCheckoutEm(row)).format('DD/MM/YYYY HH:mm')}</td>
												<td title={buildCheckoutEtapaTitle(row)}>
													<span className="CarrinhosAbandonados-etapaLabel">{formatCheckoutEtapa(row)}</span>
													{lastError ? (
														<>
															<span
																className="CarrinhosAbandonados-emailBadge CarrinhosAbandonados-emailBadge--checkoutError"
																title={lastError.mensagem || 'Erro no checkout'}
															>
																Erro
															</span>
															{lastError.mensagem ? (
																<div className="CarrinhosAbandonados-checkoutErrorMsg">{lastError.mensagem}</div>
															) : null}
														</>
													) : null}
												</td>
												<td className="CarrinhosAbandonados-colEmail">{row.email}</td>
												<td>{row.nome}</td>
												<td>{row.telefone}</td>
												<td>
													<ul className="CarrinhosAbandonados-items">
														{(row.itens || []).map((it, idx) => (
															<li key={idx}>
																{it.nome || it.produto || '—'} × {it.quantidade}
															</li>
														))}
													</ul>
												</td>
												<td>{formatMoney(subtotal)}</td>
												<td>
													{row.lembreteEnviadoEm ? (
														<span
															className="CarrinhosAbandonados-emailBadge CarrinhosAbandonados-emailBadge--reminderSent"
															title="Lembrete de carrinho abandonado enviado (~1h após checkout)"
														>
															{moment(row.lembreteEnviadoEm).format('DD/MM/YYYY HH:mm')}
														</span>
													) : (
														<span className="CarrinhosAbandonados-emailBadge CarrinhosAbandonados-emailBadge--reminderPending">
															Não enviado
														</span>
													)}
												</td>
												<td>
													{row.convertidoEm ? (
														<span
															className="CarrinhosAbandonados-emailBadge CarrinhosAbandonados-emailBadge--converted"
															title="Pagamento concluído no checkout"
														>
															{moment(row.convertidoEm).format('DD/MM/YYYY HH:mm')}
														</span>
													) : (
														<span className="CarrinhosAbandonados-emailBadge CarrinhosAbandonados-emailBadge--pending">
															Abandonado
														</span>
													)}
												</td>
												<td className="CarrinhosAbandonados-colActions">
													{!row.convertidoEm ? (
														<button
															type="button"
															className="CarrinhosAbandonados-createOrderBtn"
															onClick={() => this.createOrderFromCart(row)}
														>
															Criar pedido
														</button>
													) : (
														<span className="CarrinhosAbandonados-noAction">—</span>
													)}
												</td>
											</tr>
										);
									})}
								</tbody>
								</table>
							</div>
						</div>
						<Paginacao atual={atual} total={total} limite={limit} onClick={this.changePage} />
					</>
				) : null}
			</div>
		);
	}
}

const mapStateToProps = (state) => ({ usuario: state.auth.usuario });

export default connect(mapStateToProps)(CarrinhosAbandonados);
